module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/core-js/library/modules/$.is-object.js
// module id = 742
// module chunks = 0